export const DL_EVENTS_CONFIGURATION = {
  ACCOUNT_PREFERENCE_SAVED: {
    action: 'accountPreferences',
    clickLocation: 'my account preferences',
    clickName: 'my account select preferences',
    clickAction: 'select preferences',
    clickText: 'select preferences',
    clickDescription: 'account:wine prefences:select preference',
  },
  CHECKOUT_STEP_4_PURCHASE: {
    event: 'checkoutStep4Purchase',
    clickDescription: 'checkout: complete',
    clickName: 'checkout step 4 complete',
    clickLocation: 'Checkout',
    clickText: 'checkoutStep4Purchase',
    clickAction: 'checkout step 4 complete',
  },
};

// Shared event name and click location for all checkout step interaction events (CHECK-917)
export const CHECKOUT_STEP_EVENTS = {
  STEP_1_DELIVERY_ADDRESS: 'checkoutStep1DeliveryAddress',
  STEP_2_DELIVERY_METHOD: 'checkoutStep2DeliveryMethod',
  STEP_3_REVIEW_AND_PAY: 'checkoutStep3ReviewAndPay',
} as const;

export const CHECKOUT_CLICK_LOCATION = 'Checkout';

// Step 1 (Delivery Address) interaction click payloads. The Click Next clickDescription is built
// dynamically to capture the user's selection (delivery vs collection:store).
export const CHECKOUT_STEP_1_INTERACTIONS = {
  START: {
    clickDescription: 'checkout: step 1 start',
    clickName: 'checkout step 1 start',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 start',
  },
  ENTER_EMAIL: {
    clickDescription: 'checkout: enter email address',
    clickName: 'enter email address',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 enter email address',
  },
  SEARCH_ADDRESS: {
    clickDescription: 'checkout: search address',
    clickName: 'search address',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 search address',
  },
  ADD_DELIVERY_INSTRUCTION: {
    clickDescription: 'checkout: add delivery instruction',
    clickName: 'add delivery instruction',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 add delivery instruction',
  },
  SELECT_CLICK_AND_COLLECT: {
    clickDescription: 'checkout: select click and collect',
    clickName: 'select click and collect',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 select click and collect',
  },
  SELECT_STORE: {
    clickDescription: 'checkout: click and collect choose store',
    clickName: 'choose click and collect store',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 choose click and collect store',
  },
  SORT_DISTANCE: {
    clickDescription: 'checkout: click and collect store sort distance',
    clickName: 'click and collect store sort',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 click and collect store sort',
  },
  CLICK_NEXT: {
    clickName: 'checkout step 1 click next',
    clickText: CHECKOUT_STEP_EVENTS.STEP_1_DELIVERY_ADDRESS,
    clickAction: 'checkout step 1 click next',
  },
} as const;

// Step 2 (Delivery Method) interaction click payloads. The Select method and Click Next
// clickDescriptions are built dynamically to capture the chosen method and gift selection.
export const CHECKOUT_STEP_2_INTERACTIONS = {
  START: {
    clickDescription: 'checkout: step 2 start',
    clickName: 'checkout step 2 start',
    clickText: CHECKOUT_STEP_EVENTS.STEP_2_DELIVERY_METHOD,
    clickAction: 'checkout step 2 start',
  },
  SELECT_DELIVERY_METHOD: {
    clickName: 'select delivery method',
    clickText: CHECKOUT_STEP_EVENTS.STEP_2_DELIVERY_METHOD,
    clickAction: 'checkout step 2 select delivery method',
  },
  ADD_UNLIMITED: {
    clickDescription: 'checkout: add unlimited',
    clickName: 'add unlimited membership',
    clickText: CHECKOUT_STEP_EVENTS.STEP_2_DELIVERY_METHOD,
    clickAction: 'checkout step 2 add unlimited membership',
  },
  ADD_GREETINGS_CARD: {
    clickDescription: 'checkout: greetings card added',
    clickName: 'add greetings card',
    clickText: CHECKOUT_STEP_EVENTS.STEP_2_DELIVERY_METHOD,
    clickAction: 'checkout step 2 add greetings card',
  },
  CLICK_NEXT: {
    clickName: 'checkout step 2 click next',
    clickText: CHECKOUT_STEP_EVENTS.STEP_2_DELIVERY_METHOD,
    clickAction: 'checkout step 2 click next',
  },
} as const;

// Step 3 (Review and Pay) interaction click payloads. The Add gift card, Select payment method
// and Confirm and pay clickDescriptions are built dynamically to capture the card number / method.
export const CHECKOUT_STEP_3_INTERACTIONS = {
  START: {
    clickDescription: 'checkout: step 3 start',
    clickName: 'checkout step 3 start',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 start',
  },
  ADD_DOB: {
    clickDescription: 'checkout: add dob',
    clickName: 'add dob',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 add dob',
  },
  ADD_SUBSCRIBE_SAVE: {
    clickDescription: 'checkout: add subscribe and save',
    clickName: 'add subscribe and save',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 add subscribe and save',
  },
  ADD_GIFT_CARD: {
    clickName: 'add gift card number',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 add gift card number',
  },
  SELECT_PAYMENT_METHOD: {
    clickName: 'select payment method',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 select payment method',
  },
  SAVE_PAYMENT_DETAILS: {
    clickDescription: 'checkout: save payment details',
    clickName: 'save payment details',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 save payment details',
  },
  CONFIRM_AND_PAY: {
    clickName: 'checkout step 3 click confirm and pay',
    clickText: CHECKOUT_STEP_EVENTS.STEP_3_REVIEW_AND_PAY,
    clickAction: 'checkout step 3 click confirm and pay',
  },
} as const;

// Order Summary interaction event name and click payloads. Update quantity clickDescription
// is built dynamically to capture the direction (+ / -).
export const CHECKOUT_ORDER_SUMMARY_EVENT = 'checkoutOrderSummary';

export const CHECKOUT_ORDER_SUMMARY_INTERACTIONS = {
  EDIT_ORDER: {
    clickDescription: 'checkout: edit order',
    clickName: 'edit order',
    clickText: CHECKOUT_ORDER_SUMMARY_EVENT,
    clickAction: 'checkout order summary: edit order',
  },
  UPDATE_QUANTITY: {
    clickText: CHECKOUT_ORDER_SUMMARY_EVENT,
  },
  REMOVE_ITEM: {
    clickDescription: 'checkout: remove item',
    clickName: 'remove item',
    clickText: CHECKOUT_ORDER_SUMMARY_EVENT,
    clickAction: 'checkout order summary: remove item',
  },
} as const;

// Checkout Error event. clickDescription / clickAction are built dynamically as
// checkout:[step]:[field]:[error message] (field omitted when not applicable).
export const CHECKOUT_ERROR_EVENT = 'checkoutError';

export const CHECKOUT_ERROR_INTERACTION = {
  clickName: 'checkout error',
  clickLocation: 'Checkout Error',
} as const;
